import React, { useEffect, useState } from "react";
import { getActiveHttpRequests, subscribeHttpLoading } from "../../api/http";

const SHOW_DELAY_MS = 120;

export default function GlobalLoadingOverlay() {
  const [activeRequests, setActiveRequests] = useState(getActiveHttpRequests());
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeHttpLoading(setActiveRequests);
    return unsubscribe;
  }, []);

  useEffect(() => {
    let timeoutId = null;
    if (activeRequests > 0) {
      timeoutId = window.setTimeout(() => setVisible(true), SHOW_DELAY_MS);
    } else {
      setVisible(false);
    }
    return () => {
      if (timeoutId) window.clearTimeout(timeoutId);
    };
  }, [activeRequests]);

  if (!visible) return null;

  return (
    <div className="global-loading-overlay" role="status" aria-live="polite" aria-label="Loading">
      <div className="global-loading-card">
        <span className="global-loading-spinner" />
        <span className="global-loading-text">Loading...</span>
      </div>
    </div>
  );
}
